import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";
import { SITE } from "@/lib/site";

export const MobileBar = () => (
  <div data-testid="mobile-action-bar" className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 gap-2 p-3 bg-ink/90 backdrop-blur-xl border-t border-white/10" style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}>
    <a href={SITE.tel} data-testid="mobile-call-button" className="flex items-center justify-center gap-2 h-12 rounded-full border border-white/25 text-white font-bold text-sm">
      <Phone className="h-4 w-4 text-brass" /> Call now
    </a>
    <Link to="/book" data-testid="mobile-book-button" className="flex items-center justify-center gap-2 h-12 rounded-full bg-brass text-ink font-bold text-sm">
      <CalendarCheck className="h-4 w-4" /> Book / Quote
    </Link>
  </div>
);
